<template>
  <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="blue darken-2 white--text">
        <span class="headline">新規フォルダの作成</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense>
              <v-col cols="12" class="px-3">
                <v-text-field required ref="name"
                  v-model="form.name"
                  label="新規フォルダ名"
                  :rules="rules.name"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text
          color="secondary"
          @click="close">閉じる</v-btn>
        <v-btn depressed color="secondary white--text"
          :disabled="!isValid"
          :loading="isLoading"
          @click="submit">保存する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'mkdirModal',
  props: [
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        }
      },
      meta: {
      },
      form: {
        valid: true,
        name: ''
      },
      store: {
        item: null
      },
      rules: {
        name: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        name: ''
      })
    },
    open: function (item) {
      if (item) {
        this.init()
        this.$set(this.store, 'item', item)
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.$refs.name.focus()
        })
      }
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        if (this.store.item && this.store.item.id) {
          this.$set(this.config.status, 'loading', true)
          this.$firebase.auth().currentUser.getIdToken(true).then(token => {
            this.axios.post(this.$url.api + 'box/mkdir/' + this.store.item.id, {
              name: this.form.name.replace('/', '-').trim()
            }, {
              headers: {
                'firebase-token': token
              }
            }).then(res => {
              console.log(res)
              this.$set(this.config.status, 'loading', false)
              if (res.data && res.data.success) {
                this.$emit('emit', {
                  action: 'mkdired',
                  data: res.data.data
                })
                this.close()
              } else if (
                res.data &&
                res.data.data &&
                res.data.data.response &&
                res.data.data.response.body &&
                res.data.data.response.body.code
              ) {
                let code = res.data.data.response.body.code
                let err = this.$error.box.folder.mkdir[code] ? this.$error.box.folder.mkdir[code] : ''
                if (err) {
                  this.$store.dispatch('notifier/addAlert', {
                    title: 'フォルダの新規作成',
                    message: err
                  })
                }
              }
            })
          })
        }
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    }
  }
}
</script>
